<template>
<div id="footerbar">
<footer class="bg-dark type-2">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <div class="footer-block">
                                <!-- <img src="/static/img/theme-1/logo.png" alt="" class="logo-footer"> -->
                                <div class="f_text color-grey-7">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                                    ut labore magna aliqua. Ut aliquip ex ea commodo consequat.</div>
                                <div class="footer-share">
                                
                                    <a href="#">
                                        <span class="fa fa-facebook"></span>
                                    </a>
                                    <a href="#">
                                            <span class="fa fa-instagram"></span>
                                        </a>
                                    <a href="#">
                                        <span class="fa fa-twitter"></span>
                                    </a>
                                    <a href="#">
                                        <span class="fa fa-google-plus"></span>
                                    </a>
                                    <a href="#">
                                        <span class="fa fa-pinterest"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-sm-6 no-padding">
                            <div class="footer-block">
                                <h6>Otro</h6>
                                <!--
                        <div class="f_news clearfix">
                            <a class="f_news-img black-hover" href="#">
                                <img class="/static/img-responsive" src="/static/img/home_6/news_1.jpg" alt="">
                                <div class="tour-layer delay-1"></div>
                            </a>
                            <div class="f_news-content">
                                <a class="f_news-tilte color-white link-red" href="#">amazing place</a>
                                <span class="date-f">Mar 18, 2015</span>
                                <a href="#" class="r-more">read more</a>
                            </div>
                        </div>
                        <div class="f_news clearfix">
                            <a class="f_news-img black-hover" href="#">
                                <img class="/static/img-responsive" src="/static/img/home_6/news_2.jpg" alt="">
                                <div class="tour-layer delay-1"></div>
                            </a>
                            <div class="f_news-content">
                                <a class="f_news-tilte color-white link-red" href="#">amazing place</a>
                                <span class="date-f">Mar 18, 2015</span>
                                <a href="#" class="r-more">read more</a>
                            </div>
                        </div>
                        <div class="f_news clearfix">
                            <a class="f_news-img black-hover" href="#">
                                <img class="/static/img-responsive" src="/static/img/home_6/news_1.jpg" alt="">
                                <div class="tour-layer delay-1"></div>
                            </a>
                            <div class="f_news-content">
                                <a class="f_news-tilte color-white link-red" href="#">amazing place</a>
                                <span class="date-f">Mar 18, 2015</span>
                                <a href="#" class="r-more">read more</a>
                            </div>
                        </div>
                    -->
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <div class="footer-block">
                                <h6>Espacio para logos:</h6>

                            </div>
                        </div>
                        <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                            <div class="footer-block">
                                <h6>Contact Info</h6>
                                <div class="contact-info">
                                    <div class="contact-line color-grey-3">
                                        <i class="fa fa-map-marker"></i>
                                        <span>Taganga, Santa Marta</span>
                                    </div>
                                    <div class="contact-line color-grey-3">
                                        <i class="fa fa-phone"></i>
                                        <a href="tel:57 (5) 4 219057">57 (5) 4 219057</a>
                                    </div>
                                    <div class="contact-line color-grey-3">
                                        <i class="fa fa-whatsapp"></i>
                                        <a href="intent://send/+573167561312#Intent;scheme=smsto;package=com.whatsapp;action=android.intent.action.SENDTO;end">+57 316 756 13 12</a>
                                    </div>
                                    <div class="contact-line color-grey-3">
                                        <i class="fa fa-envelope-o"></i>
                                        <a href="mailto://peli.k@hotmail.com">
                                            peli.k@hotmail.com
                                        </a>
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-link bg-black">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="copyright">
                                    <span>&copy; 2017 Hostal Pelikan Taganga</span>
                                </div>

                                <ul>
                                    <li>
                                        <a class="link-aqua" href="#">Privacy Policy </a>
                                    </li>

                                    <li>
                                        <a class="link-aqua" href="#">Sitemap</a>
                                    </li>
                                    <!--
                            <li>
                                <a class="link-aqua" href="#">Blog</a>
                            </li>
                            <li>
                                <a class="link-aqua" href="#"> Forum</a>
                            </li>
                        -->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>    
</div>
</template>

<script>
export default {
  methods: {
  },
  computed: {
  },
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: 'Hello World!'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Footerbar.vue?0080e82f